import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Cpu } from "lucide-react";
import { useApi, errMsg } from "@/lib/api";

export const AIModelPanel = () => {
  const api = useApi();
  const [d, setD] = useState(null);
  useEffect(() => { api("get", "/admin/ai-model").then(setD).catch(() => {}); }, [api]);
  if (!d) return null;
  const pick = async (model) => {
    try { await api("put", "/admin/ai-model", { model }); setD({ ...d, model }); toast.success(`${d.options[model]} will write analyses and read imports`); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <section className="rounded-2xl bg-[#131C31] border border-white/5 p-5" data-testid="admin-ai-model-panel">
      <h2 className="font-display text-lg font-bold mb-1 flex items-center gap-2"><Cpu className="w-4 h-4 text-blue-400" />AI model</h2>
      <p className="text-xs text-slate-500 mb-3">Used for race analysis and form-guide imports. All follow the same verified-facts-only rules.</p>
      <div className="flex flex-wrap gap-2">
        {Object.entries(d.options).map(([k, label]) => (
          <button key={k} data-testid={`ai-model-${k}`} onClick={() => pick(k)}
            className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${d.model === k ? "bg-blue-600 border-blue-500" : "border-white/10 text-slate-300 hover:bg-white/5"}`}>{label}</button>
        ))}
      </div>
    </section>
  );
};
